import { cn } from "@/modules/lib/utils"
import { Dot } from "@images/svgIcons/charts/dot"
import { v4 as uuidv4 } from "uuid"
import { Text } from "@/components/ui/baseUi/text"

type HuDotsProps = {
  number: number
  date: string
  className?: string
} & React.ComponentProps<"div">

/**
 * Composant for render chart with dots in the Training page
 * @param number
 * @param date
 * @returns
 */
export function HuDots({ number, date, className, ...props }: HuDotsProps) {
  const gridHeight = 20
  const gridModulo = number % gridHeight
  const gridColumn = Math.floor(number / gridHeight)

  return (
    <div className={cn("flex h-full w-1/4 flex-col items-center justify-end", className)} {...props}>
      <div className="mb-2">
        <Text fontStyle="TM" className="text-textDefault-heading">
          {number}
        </Text>
      </div>
      <div>
        <div className="flex flex-row gap-0.5">
          {Array.from({ length: gridColumn }).map(() => (
            <div key={uuidv4()} className="flex flex-col gap-[1px]">
              {Array.from({ length: gridHeight }).map(() => (
                <Dot key={uuidv4()} color="currentColor" className="text-textDefault-heading" />
              ))}
            </div>
          ))}
          {gridModulo > 0 && (
            <div className="flex flex-col-reverse gap-[1px]">
              {Array.from({ length: gridModulo }).map(() => (
                <Dot key={uuidv4()} color="currentColor" className="text-textDefault-heading" />
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="mt-1">
        <Text fontStyle="BS" className="text-textDefault-heading">
          {date}
        </Text>
      </div>
    </div>
  )
}
